import React, { useState, useEffect } from "react";
import { Container, Modal, Table } from "react-bootstrap";
const AuditModal = ({ data, show, setShow }) => {
  const [auditType, setAuditType] = useState("");

  useEffect(() => {
    if (data && data.objectType === "Reference") {
      setAuditType("Reference");
    } else if (data && data.objectType === "CarrierContacts") {
      setAuditType("CarrierContacts");
    } else if (data && data.objectType === "Diversity") {
      setAuditType("Diversity");
    } else if (data && data.objectType === "Site/Structure/Circuit") {
      setAuditType("Site/Structure/Circuit");
    }
  }, [data]);

  const closeModal = () => {
    setShow(false);
  };

  const formatDate = (timestamp) => {
    if (
      !timestamp ||
      timestamp === "null" ||
      timestamp === null ||
      timestamp === undefined
    )
      return "";
    const date = new Date(Number(timestamp) * 1000);
    if (isNaN(date.getTime())) return "";
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });
  };

  const renderRow = (label, before, after, boolText = false) => {
    const formatValue = (val) => {
      if (boolText) {
        if (val === null || val === undefined) return "Off";
        if (typeof val === "boolean") return val ? "On" : "Off";
      }
      return val ?? "";
    };
    return (
      <tr>
        <td>{label}</td>
        <td>{formatValue(before)}</td>
        <td>
          {after !== before ? <b>{formatValue(after)}</b> : formatValue(after)}
        </td>
      </tr>
    );
  };

  const renderCircuitModal = (data) => {
    // Helper to handle "null" string, null, or undefined
    const safe = (val) =>
      val === null || val === undefined || val === "null" ? "" : val;

    if (data.action === "DELETE") {
      return (
        <>
          {renderRow("Circuit Vendor ID", safe(data.circuitVendorId), "")}
          {renderRow("Carrier", safe(data.carrier), "")}
          {renderRow("Status", safe(data.status), "")}
          {renderRow("Structure ID", safe(data.structureId), "")}
          {renderRow("Port Bandwidth", safe(data.portBandwidth), "")}
          {renderRow("Port Bandwidth Unit", safe(data.portBandwidthUnit), "")}
          {renderRow(
            "Access Bandwidth Unit",
            safe(data.accessBandwidthUnit),
            "",
          )}
          {renderRow("Access Bandwidth", safe(data.accessBandwidth), "")}
          {renderRow("Use", safe(data.use), "")}
          {renderRow("LEC", safe(data.lec), "")}
          {renderRow("Redundancy Type", safe(data.redundancyType), "")}
          {renderRow("Diverse POP", safe(data.diversePop), "", true)}
          {renderRow(
            "Diverse Physical Path",
            safe(data.diversePhysicalPath),
            "",
            true,
          )}
          {renderRow("Note", safe(data.circuitNote), "")}
          {renderRow("Category", safe(data.category), "")}
          {renderRow("Bill To Country", safe(data.billToCountry), "")}
          {renderRow("Currency", safe(data.currency), "")}
          {renderRow("Scope", safe(data.scope), "")}
          {renderRow("Type Value", safe(data.typeValue), "")}
          {renderRow("Handoff Type", safe(data.handoffType), "")}
          {renderRow(
            "Requested Disconnect Date",
            safe(formatDate(data.requestedDisconnectDate)),
            "",
          )}
          {renderRow(
            "Forecast Delivery Date",
            safe(formatDate(data.forecastDeliveryDate)),
            "",
          )}
          {renderRow(
            "Current Term End Date",
            safe(formatDate(data.currentTermEndDate)),
            "",
          )}
          {renderRow("Cutover Date", safe(formatDate(data.cutoverDate)), "")}
          {renderRow(
            "Actual Billing Start Date",
            safe(formatDate(data.actualBillingStartDate)),
            "",
          )}
          {renderRow(
            "Actual Billing Stop Date",
            safe(formatDate(data.actualBillingStopDate)),
            "",
          )}
          {renderRow(
            "Actual Handover Date",
            safe(formatDate(data.actualHandoverDate)),
            "",
          )}
          {renderRow("MRC Baseline", safe(data.mrcBaseline), "")}
        </>
      );
    } else if (data.action === "CREATE") {
      return (
        <>
          {renderRow("Circuit Vendor ID", "", safe(data.newCircuitVendorId))}
          {renderRow("Carrier", "", safe(data.newCarrier))}
          {renderRow("Status", "", safe(data.newStatus))}
          {renderRow("Structure ID", "", safe(data.newStructureId))}
          {renderRow("Port Bandwidth", "", safe(data.newPortBandwidth))}
          {renderRow(
            "Port Bandwidth Unit",
            "",
            safe(data.newPortBandwidthUnit),
          )}
          {renderRow("Access Bandwidth", "", safe(data.newAccessBandwidth))}
          {renderRow(
            "Access Bandwidth Unit",
            "",
            safe(data.newAccessBandwidthUnit),
          )}
          {renderRow("Use", "", safe(data.newUse))}
          {renderRow("LEC", "", safe(data.newLec))}
          {renderRow("Redundancy Type", "", safe(data.newRedundancyType))}
          {renderRow("Diverse POP", "", safe(data.newDiversePop), true)}
          {renderRow(
            "Diverse Physical Path",
            "",
            safe(data.newDiversePhysicalPath),
            true,
          )}
          {renderRow("Note", "", safe(data.newCircuitNote))}
          {renderRow("Category", "", safe(data.newCategory))}
          {renderRow("Bill To Country", "", safe(data.newBillToCountry))}
          {renderRow("Currency", "", safe(data.newCurrency))}
          {renderRow("Scope", "", safe(data.newScope))}
          {renderRow("Type Value", "", safe(data.newTypeValue))}
          {renderRow("Handoff Type", "", safe(data.newHandoffType))}
          {renderRow(
            "Requested Disconnect Date",
            "",
            safe(formatDate(data.newRequestedDisconnectDate)),
          )}
          {renderRow(
            "Forecast Delivery Date",
            "",
            safe(formatDate(data.newForecastDeliveryDate)),
          )}
          {renderRow(
            "Current Term End Date",
            "",
            safe(formatDate(data.newCurrentTermEndDate)),
          )}
          {renderRow("Cutover Date", "", safe(formatDate(data.newCutoverDate)))}
          {renderRow(
            "Actual Billing Start Date",
            "",
            safe(formatDate(data.newActualBillingStartDate)),
          )}
          {renderRow(
            "Actual Billing Stop Date",
            "",
            safe(formatDate(data.newActualBillingStopDate)),
          )}
          {renderRow(
            "Actual Handover Date",
            "",
            safe(formatDate(data.newActualHandoverDate)),
          )}
          {renderRow("MRC Baseline", "", safe(data.newMrcBaseline))}
        </>
      );
    } else {
      // UPDATE or default
      return (
        <>
          {renderRow(
            "Circuit Vendor ID",
            safe(data.circuitVendorId),
            safe(data.newCircuitVendorId),
          )}
          {renderRow("Carrier", safe(data.carrier), safe(data.newCarrier))}
          {renderRow("Status", safe(data.status), safe(data.newStatus))}
          {renderRow(
            "Structure ID",
            safe(data.structureId),
            safe(data.newStructureId),
          )}
          {renderRow(
            "Port Bandwidth",
            safe(data.portBandwidth),
            safe(data.newPortBandwidth),
          )}
          {renderRow(
            "Port Bandwidth Unit",
            safe(data.portBandwidthUnit),
            safe(data.newPortBandwidthUnit),
          )}
          {renderRow(
            "Access Bandwidth",
            safe(data.accessBandwidth),
            safe(data.newAccessBandwidth),
          )}
          {renderRow(
            "Access Bandwidth Unit",
            safe(data.accessBandwidthUnit),
            safe(data.newAccessBandwidthUnit),
          )}
          {renderRow("Use", safe(data.use), safe(data.newUse))}
          {renderRow("LEC", safe(data.lec), safe(data.newLec))}
          {renderRow(
            "Redundancy Type",
            safe(data.redundancyType),
            safe(data.newRedundancyType),
          )}
          {renderRow(
            "Diverse POP",
            safe(data.diversePop),
            safe(data.newDiversePop),
            true,
          )}
          {renderRow(
            "Diverse Physical Path",
            safe(data.diversePhysicalPath),
            safe(data.newDiversePhysicalPath),
            true,
          )}
          {renderRow("Note", safe(data.circuitNote), safe(data.newCircuitNote))}
          {renderRow("Category", safe(data.category), safe(data.newCategory))}
          {renderRow(
            "Bill To Country",
            safe(data.billToCountry),
            safe(data.newBillToCountry),
          )}
          {renderRow("Currency", safe(data.currency), safe(data.newCurrency))}
          {renderRow("Scope", safe(data.scope), safe(data.newScope))}
          {renderRow(
            "Type Value",
            safe(data.typeValue),
            safe(data.newTypeValue),
          )}
          {renderRow(
            "Handoff Type",
            safe(data.handoffType),
            safe(data.newHandoffType),
          )}
          {renderRow(
            "Requested Disconnect Date",
            safe(formatDate(data.requestedDisconnectDate)),
            safe(formatDate(data.newRequestedDisconnectDate)),
          )}
          {renderRow(
            "Forecast Delivery Date",
            safe(formatDate(data.forecastDeliveryDate)),
            safe(formatDate(data.newForecastDeliveryDate)),
          )}
          {renderRow(
            "Current Term End Date",
            safe(formatDate(data.currentTermEndDate)),
            safe(formatDate(data.newCurrentTermEndDate)),
          )}
          {renderRow(
            "Cutover Date",
            safe(formatDate(data.cutoverDate)),
            safe(formatDate(data.newCutoverDate)),
          )}
          {renderRow(
            "Actual Billing Start Date",
            safe(formatDate(data.actualBillingStartDate)),
            safe(formatDate(data.newActualBillingStartDate)),
          )}
          {renderRow(
            "Actual Billing Stop Date",
            safe(formatDate(data.actualBillingStopDate)),
            safe(formatDate(data.newActualBillingStopDate)),
          )}
          {renderRow(
            "Actual Handover Date",
            safe(formatDate(data.actualHandoverDate)),
            safe(formatDate(data.newActualHandoverDate)),
          )}
          {renderRow(
            "MRC Baseline",
            safe(data.mrcBaseline),
            safe(data.newMrcBaseline),
          )}
        </>
      );
    }
  };

  const renderContact = () => (
    <>
      {renderRow("Contact Name", data.name, data.newName)}
      {renderRow("Role", data.role, data.newRole)}
      {renderRow("Contact Type", data.contactType, data.newType)}
      {renderRow("Region", data.region, data.newRegion)}
      {renderRow("Language", data.language, data.newLanguage)}
      {renderRow("Email", data.email, data.newEmail)}
      {renderRow("Main Phone", data.mainPhone, data.newMainPhone)}
      {renderRow("Alt Phone", data.altPhone, data.newAltPhone)}
      {renderRow("Timezone", data.timezoneCode, data.newTimezoneCode)}
      {renderRow("Notes", data.notes, data.newNotes)}
    </>
  );

  const renderCarrier = () => {
    const onboardDate =
      data && data.onboardDate
        ? formatDate(data.onboardDate)
        : data && data.onboardDate;
    const newOnboardDate =
      data && data.newOnboardDate
        ? formatDate(data.newOnboardDate)
        : data && data.newOnboardDate;
    const offboardDate =
      data && data.offboardDate
        ? formatDate(data.offboardDate)
        : data && data.offboardDate;
    const newOffboardDate =
      data && data.newOffboardDate
        ? formatDate(data.newOffboardDate)
        : data && data.newOffboardDate;

    return (
      <>
        {renderRow("Status", data.status, data.newStatus)}
        {renderRow(
          "Regions",
          Array.isArray(data.regions) ? data.regions.join(", ") : "",
          Array.isArray(data.newRegions) ? data.newRegions.join(", ") : "",
        )}
        {renderRow("City", data.city, data.newCity)}
        {renderRow("Country", data.country, data.newCountry)}
        {renderRow("State", data.state, data.newState)}
        {renderRow("Postcode", data.postcode, data.newPostcode)}
        {renderRow("Address 1", data.address1, data.newAddress1)}
        {renderRow("Address 2", data.address2, data.newAddress2)}
        {renderRow("Notes", data.notes, data.newNotes)}
        {renderRow("Onboard Date", onboardDate, newOnboardDate)}
        {renderRow("Offboard Date", offboardDate, newOffboardDate)}
      </>
    );
  };

  const renderDiversityGroup = () => {
    if (data.action === "DELETE") {
      return (
        <>
          {renderRow("Diversity Group Name", data.groupName, data.newGroupName)}
          {renderRow("Diversity", data.diversity, data.newDiversity)}
          {renderRow("Reporting", data.reporting, "", true)}
        </>
      );
    }
    if (data.action === "CREATE") {
      return (
        <>
          {renderRow("Diversity Group Name", data.groupName, data.newGroupName)}
          {renderRow("Diversity", data.diversity, data.newDiversity)}
          {renderRow("Reporting", "", data.newReporting, true)}
        </>
      );
    }
    return (
      <>
        {renderRow("Diversity Group Name", data.groupName, data.newGroupName)}
        {renderRow("Diversity", data.diversity, data.newDiversity)}
        {renderRow("Reporting", data.reporting, data.newReporting, true)}
      </>
    );
  };

  const renderReferenceModal = (data) => {
    if (data.action === "CREATE") {
      return (
        <>
          {renderRow("Description", "", data.description)}
          {renderRow("Enabled", "", data.newEnabled, true)}
        </>
      );
    } else {
      return (
        <>
          {renderRow("Description", data.description, data.description)}
          {renderRow("Enabled", data.enabled, data.newEnabled, true)}
        </>
      );
    }
  };

  const renderSiteModal = (data) => {
    if (data.action === "DELETE") {
      return (
        <>
          {renderRow("Site Name", data.identifier, "")}
          {renderRow("Country", data.country, "")}
          {renderRow("City", data.city, "")}
          {renderRow("Status", data.status, "")}
          {renderRow("Site Type", data.siteType, "")}
          {renderRow("Parent Site ID", data.parentSiteId, "")}
          {renderRow("Note", data.note, "")}
          {renderRow("Country Code", data.countryCode, "")}
        </>
      );
    } else if (data.action === "CREATE") {
      return (
        <>
          {renderRow("Site Name", "", data.identifier)}
          {renderRow("Country", "", data.country)}
          {renderRow("City", "", data.city)}
          {renderRow("Status", "", data.status)}
          {renderRow("Site Type", "", data.siteType)}
          {renderRow("Parent Site ID", "", data.parentSiteId)}
          {renderRow("Note", "", data.new_note)}
          {renderRow("Country Code", "", data.countryCode)}
        </>
      );
    } else {
      return (
        <>
          {renderRow("Site Name", data.identifier, data.identifier)}
          {renderRow("Country", data.country, data.country)}
          {renderRow("City", data.city, data.city)}
          {renderRow("Status", data.status, data.status)}
          {renderRow("Site Type", data.siteType, data.siteType)}
          {renderRow("Parent Site ID", data.parentSiteId, data.parentSiteId)}
          {renderRow("Note", data.note, data.new_note)}
          {renderRow("Country Code", data.countryCode, data.countryCode)}
        </>
      );
    }
  };

  const renderStructureModal = (data) => {
    if (data.action === "DELETE") {
      return (
        <>
          {renderRow("Structure Name", data.structureName, "")}
          {renderRow("Structure ID", data.structureId, "")}
          {renderRow("Country", data.country, "")}
          {renderRow("City", data.city, "")}
          {renderRow("Status", data.status, "")}
          {/* {renderRow("Parent Site ID", data.parentSiteId, "")} */}
        </>
      );
    } else if (data.action === "CREATE") {
      return (
        <>
          {renderRow("Structure Name", "", data.structureName)}
          {renderRow("Structure ID", "", data.structureId)}
          {renderRow("Country", "", data.country)}
          {renderRow("City", "", data.city)}
          {renderRow("Status", "", data.status)}
          {/* {renderRow("Parent Site ID", "", data.parentSiteId)} */}
        </>
      );
    }
  };

  return (
    <Container>
      <Modal
        show={show}
        onHide={closeModal}
        dialogClassName="info-modal"
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
      >
        <Modal.Header
          style={{ border: "none", flexShrink: 0 }}
          className="ms-2 me-2"
          closeButton
        >
          <Modal.Title>
            {" "}
            Changes Made for{" "}
            {data.name ||
              data.diversityGroupName ||
              data.carrierName ||
              data.modalName ||
              data.identifier ||
              ""}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body
          style={{
            overflowY: "auto",
            flex: 1,
            padding: "1rem",
          }}
        >
          <div className="info-modal-table-scroll">
            <Table striped bordered hover>
              <thead>
                <tr>
                  <th style={{ minWidth: "220px" }}>Details</th>
                  <th>Before</th>
                  <th>After</th>
                </tr>
              </thead>
              <tbody>
                {auditType === "Reference" && renderReferenceModal(data)}
                {auditType === "CarrierContacts" &&
                  data.type === "Carrier" &&
                  renderCarrier()}
                {auditType === "CarrierContacts" &&
                  data.type === "Contact" &&
                  renderContact()}
                {auditType === "Diversity" && renderDiversityGroup()}
                {auditType === "Site/Structure/Circuit" &&
                  data.type === "Site" &&
                  renderSiteModal(data)}
                {auditType === "Site/Structure/Circuit" &&
                  data.type === "Structure" &&
                  renderStructureModal(data)}
                {auditType === "Site/Structure/Circuit" &&
                  data.type === "Circuit" &&
                  renderCircuitModal(data)}
              </tbody>
            </Table>
          </div>
        </Modal.Body>
      </Modal>
    </Container>
  );
};

export default AuditModal;
